/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seo_Sitename1Inputs */

const he_seo_sitename1 = /** @type {(inputs: Seo_Sitename1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pricedrop`)
};

const en_seo_sitename1 = /** @type {(inputs: Seo_Sitename1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pricedrop`)
};

/**
* | output |
* | --- |
* | "Pricedrop" |
*
* @param {Seo_Sitename1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const seo_sitename1 = /** @type {((inputs?: Seo_Sitename1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Sitename1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_seo_sitename1(inputs)
	return en_seo_sitename1(inputs)
});
export { seo_sitename1 as "seo_siteName" }